import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  isDailogOpen: false,
  isTechnicialFilterApplied: false,
};
const schedulerTechnicianViewSlice = createSlice({
  name: 'schedulerTechnicianView',
  initialState: initialState,
  reducers: {
    setFilterTechinicianView(state, { payload }) {
      state.isDailogOpen = Object.prototype.hasOwnProperty.call(
        payload,
        'isDailogOpen'
      )
        ? payload.isDailogOpen
        : state.isDailogOpen;
      state.isTechnicialFilterApplied = Object.prototype.hasOwnProperty.call(
        payload,
        'isTechnicialFilterApplied'
      )
        ? payload.isTechnicialFilterApplied
        : state.isTechnicialFilterApplied;
    },
  },
});
export const { setFilterTechinicianView } =
  schedulerTechnicianViewSlice.actions;
export const schedulerTechnicianViewReducer =
  schedulerTechnicianViewSlice.reducer;
